export const QueryParamNames = {
  Domain: 'domain',
} as const;

type QueryParamName = typeof QueryParamNames[keyof typeof QueryParamNames];

const QueryParamNamesList = Object.values(QueryParamNames);

export type DiagnosticsQueryParams = Partial<{
  domain: string[];
}>;

export function isDiagnosticsParam(name: string): name is QueryParamName {
  return QueryParamNamesList.includes(name as QueryParamName);
}

export function buildDiagnosticsQueryParameters(
  data: Record<string, string>
): DiagnosticsQueryParams {
  return Object.entries(data).reduce<DiagnosticsQueryParams>((acc, [name, value]) => {
    if (!isDiagnosticsParam(name)) return acc;

    if (name === QueryParamNames.Domain) {
      acc[name] = value.split(',');
    }

    return acc;
  }, {});
}
